"use client";

/**
 * AttributionTracker
 *
 * Mounted in the root layout. On first load, captures organic traffic by
 * inspecting URL UTM params and document.referrer, and writes a first-touch
 * attribution cookie. Tracked /go/[slug] links handle their own cookie write
 * server-side, so this component is a no-op for those visits (the cookie will
 * already exist).
 *
 * Renders nothing.
 */

import { useEffect } from "react";
import { detectAttributionFromBrowser, writeAttributionCookie } from "@/lib/attribution/cookie";

export default function AttributionTracker() {
  useEffect(() => {
    const detected = detectAttributionFromBrowser();
    if (detected) {
      // first-touch: writeAttributionCookie no-ops if a cookie already exists
      writeAttributionCookie(detected);
    }
  }, []);

  return null;
}
